import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { createHttpExtraOptions } from '@vision/ui/utils';
import { axiosBaseQuery } from '../base.service';
import type { CreateCsvTemplateArgs, CsvTemplateDto, GetCsvTemplatesArgs } from './csv-templates.api.types';
import { fromApiCsvTemplate, toApiCreateCsvTemplate } from './csv-templates.mapper';
import type { CsvTemplate } from './types';

// Saved column mappings of the legacy sharing modals; there is no v2 endpoint.
export const CsvTemplatesService = createApi({
  reducerPath: 'CsvTemplatesService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['CsvTemplates'],
  endpoints: (builder) => ({
    getCsvTemplates: builder.query<CsvTemplate[], GetCsvTemplatesArgs>({
      query: ({ accountId, type }) => ({
        url: '/v1/csv_templates',
        method: HttpMethod.GET,
        params: { node_id: accountId, type },
      }),
      providesTags: ['CsvTemplates'],
      transformResponse: (response: CsvTemplateDto[]) => response.map(fromApiCsvTemplate),
    }),
    // The API rejects a mapping without the identifier fields the template type needs.
    createCsvTemplate: builder.mutation<CsvTemplate, CreateCsvTemplateArgs>({
      query: ({ accountId, ...template }) => ({
        url: '/v1/csv_templates',
        method: HttpMethod.POST,
        params: { node_id: accountId },
        data: toApiCreateCsvTemplate(template),
        // The caller shows its own success message.
        extraOptions: createHttpExtraOptions({ notification: { autoHandleSuccess: false } }),
      }),
      invalidatesTags: (_result, error) => (error ? [] : ['CsvTemplates']),
      transformResponse: (response: CsvTemplateDto) => fromApiCsvTemplate(response),
    }),
  }),
});

export const { useCreateCsvTemplateMutation, useGetCsvTemplatesQuery } = CsvTemplatesService;
